import script from "./OpsSecurity.vue?vue&type=script&setup=true&lang=js"
export * from "./OpsSecurity.vue?vue&type=script&setup=true&lang=js"

import "./OpsSecurity.vue?vue&type=style&index=0&id=3c0b3766&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c0b3766"]])

export default __exports__